import { render, staticRenderFns } from "./InterviewAnswerImages.vue?vue&type=template&id=4bdc28e8&scoped=true"
import script from "./InterviewAnswerImages.vue?vue&type=script&lang=js"
export * from "./InterviewAnswerImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdc28e8",
  null
  
)

export default component.exports